<template>
    <div>
        <div class="text-end mb-2">
            <button
                class="btn btn-primary"
                @click="openAddComment"
            >
                Add comment
            </button>
        </div>
        
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th class="d-none">ID</th>
                        <th>Date</th>
                        <th>From</th>
                        <th class="col-8">Comment</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="note in notes" :key="note.id">
                        <tr @click="toggleDetails(note)" style="cursor: pointer;">
                            <td class="d-none">{{ note.id }}</td>
                            <td>{{ note.comment_date }}</td>
                            <td>{{ note.comment_from_user_id }}</td>
                            <td class="col-8">
                                <span style="text-overflow: ellipsis;">
                                    {{ note.comment }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="note._showDetails">
                            <td colspan="4">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row mb-2">
                                            <div class="col-sm-2 text-start"><b>Comment:</b></div>
                                            <div class="col-sm-10">{{ note.comment }}</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        
        <!-- Add Comment Modal -->
        <div class="modal fade" :class="{show: showAddCommentModal, 'd-block': showAddCommentModal}" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add comment</h5>
                        <button type="button" class="btn-close" @click="closeAddComment"></button>
                    </div>
                    <div class="modal-body">
                        <textarea
                            class="form-control"
                            v-model="newComment"
                            placeholder="Enter comment"
                            rows="4"
                        ></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeAddComment">Close</button>
                        <button type="button" class="btn btn-primary" @click="saveAddComment">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showAddCommentModal" class="modal-backdrop fade show"></div>
    </div>
</template>
<script>
export default {
  name: 'ExamNotes',
  props: {
    examanswerId: {
        type: [String, Number],
        default: ''
    },
  },
  async created() {
    await this.notes_get();
  },
  data() {
    return {
        notes: [],
        notecolumns: [
            { key: 'id', label: 'ID', thClass: 'd-none', tdClass: 'd-none' },
            { key: 'comment_date', label: 'Date' },
            { key: 'comment_from_user_id', label: 'From' },
            { key: 'comment', label: 'Comment', thClass: 'col-8',tdClass:'col-8' },
        ],
        showAddCommentModal: false,
        newComment: '',
        user_id: this.$store.state.user_id,
    }
  },
  methods: {
    toggleDetails(note) {
        note._showDetails = !note._showDetails;
        this.$forceUpdate();
    },
    saveAddComment() {
        this.$store.dispatch('record_post', {
            table_name: 'g_elearning_consultant_exam_answer_notes',
            record: {
                examanswer_id: this.examanswerId,
                examanswer_comment: this.newComment,
                comment_date: null,
                comment_from_user_id: this.$store.state.user_id,
            }
        }).then(() => {
            this.closeAddComment();
            this.notes_get();
        });
    },
    openAddComment() {
        this.newComment = '';
        this.showAddCommentModal = true;
    },
    closeAddComment() {
        this.newComment = '';
        this.showAddCommentModal = false;
    },
    async notes_get() {
        const filter = {
            examanswer_id: {
                value: this.examanswerId,
                operator: '='
            }
        }
        let notes = await this.$store.dispatch('records_readlist', {
            table_name: 'g_elearning_consultant_exam_answer_notes',
            filter,
        }).then(r => r.data.result);
        notes.sort((a, b) => b.id - a.id);
        this.notes = [];
        for (let note of notes) {
            await this.$store.dispatch('record_read', {
                table_name: 'g_elearning_consultant_exam_answer_notes',
                id: note.id
            }).then(r => {
                note.comment = r.data.examanswer_comment.trim();
                this.$store.dispatch('record_read', {
                    table_name: 'i_user',
                    id: note._comment_from_user_id
                }).then(r => {
                    note.comment_from_user_id = `${r.data.first_name} ${r.data.family_name}`;
                });
            });
            if (note.comment !== '') {
                note._showDetails = false;
                this.notes.push(note);
            }
        }
    }
  }
}
</script>
<style>
</style>
